<template>
  <div class="main">
    <div class="contain">
      <el-button type="primary" @click="back">返回上一页</el-button>
      <p class="label"><span class="require">*</span>发布人：</p>
      <el-input
        placeholder="请输入发布人"
        v-model="contact"
        class="inputItem"
      ></el-input>
      <p class="label"><span class="require">*</span>联系手机号码：</p>
      <el-input
        type="number"
        placeholder="请输入联系手机号码"
        v-model="phone"
        class="inputItem"
        maxlength="11"
      ></el-input>
      <p class="label"><span class="require">*</span>工作类型：</p>
      <selectTreeMult
        v-model="work_type"
        :disabled="id != ''"
        :list="treeList"
        rowKey="id"
        :defaultProps="defaultProps"
        :class="{ disabledStatus: id != '' }"
      ></selectTreeMult>
      <p class="label"><span class="require">*</span>工作地址：</p>
      <el-button type="primary" class="chooseLocation" @click="mapShowFn"
        >打开地图</el-button
      >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请打开地图选择位置"
        v-model="address"
        resize="none"
        maxlength="200"
        class="locationInput"
      >
      </el-input>
      <p class="label"><span class="require">*</span>详细描述：</p>
      <el-input
        type="textarea"
        placeholder="请输入详细描述（如招工要求、工作内容、工资待遇、结款方式、周期等），有助于您更快、更准确的招到好工人～"
        v-model="description"
        resize="none"
        maxlength="200"
        class="desInput"
        show-word-limit
        :autosize="{ minRows: 5 }"
      ></el-input>
      <p class="label">图片：</p>
      <div class="imgContain">
        <div class="imgInner" v-for="(item, index) in imgs" :key="index">
          <!-- <el-image :src="item" class="uploadImg" @click="toUpload(index)" /> -->
          <el-image :src="item" class="uploadImg" :preview-src-list="imgs" />
          <img
            src="../../../assets/imgDelete.png"
            class="imgDelete"
            @click="imgDelete(index)"
          />
        </div>
        <div class="imgInner">
          <img
            src="../../../assets/script/upload.png"
            class="uploadImg"
            @click="toUpload(-1)"
            v-if="imgs.length < 3"
          />
        </div>
      </div>
      <p class="uploadInfo">
        最多可上传3张工地施工照片、工程图纸、承包合同等。支持jpg、png、jpeg格式的图片，大小不超过10M。
      </p>
      <p class="label">薪资：</p>
      <el-radio-group v-model="salary" class="salaryRadio">
        <el-radio :label="1">元/天</el-radio>
        <el-radio :label="2">元/月</el-radio>
        <el-radio :label="3">元/平</el-radio>
        <el-radio :label="0">面议</el-radio>
      </el-radio-group>
      <el-input
        type="number"
        placeholder="请输入薪资"
        v-model="salaryNum"
        class="inputItem salaryInput"
        v-if="salary > 0"
      ></el-input>
      <p class="label">人员构成：</p>
      <el-select v-model="peopleType" placeholder="请选择人员构成">
        <el-option
          v-for="item in peopleTypeOption"
          :key="item.id"
          :label="item.tag_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <p class="label" v-if="peopleType != 10 && peopleType != ''">
        <span class="require">*</span>人数：
      </p>
      <el-select
        v-model="needPeople"
        placeholder="请选择招聘人数"
        v-if="peopleType != 10 && peopleType != ''"
      >
        <el-option
          v-for="item in needPeopleOption"
          :key="item.id"
          :label="item.tag_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="btnContain">
        <el-button type="primary" @click="submit">发布</el-button>
        <el-button type="primary" @click="reset" class="resetBtn"
          >重置</el-button
        >
      </div>
    </div>

    <el-dialog
      title="选择位置"
      width="80%"
      :visible.sync="mapShow"
      top="5vh"
      class="mapContainer"
      @open="mapOpen"
      v-loading.fullscreen.lock="mapLoading"
      element-loading-text="地图加载中"
    >
      <el-input
        v-model="searchMap"
        placeholder="搜索"
        class="searchMap"
        @keyup.native.enter="searchMapFn"
      ></el-input>
      <el-button @click="searchMapFn" type="primary">搜索</el-button>
      <div id="container"></div>
      <div id="panel"></div>
    </el-dialog>

    <input type="file" @change="fileChange" id="upload" style="display: none" />
  </div>
</template>

<script>
import { RECRUIT_HOST } from "../../../constants/apiHosts";
import { HS_upload } from "./../../../utils/huoshanUpload";
import selectTreeMult from "./components/selectTreeMult.vue";

export default {
  components: {
    selectTreeMult,
  },
  data() {
    return {
      id: "",
      mapLoading: false,
      mapShow: false,
      AMap: {},
      map: "",
      placeSearch: {},
      geocoder: {},
      searchMap: "",
      position: {},
      lon: "",
      lat: "",
      address: "",
      imgs: [],
      uploadIndex: 0,
      salary: -1,
      salaryNum: "",
      peopleTypeOption: [],
      peopleType: "",
      needPeopleOption: [],
      needPeople: "",
      treeList: [],
      work_type: [],
      contact: "",
      phone: "",
      description: "",
      defaultProps: {
        label: "wt_name",
        children: "children",
        disabled: function (data, node) {
          if (data.pid == 0) {
            return true;
          } else {
            return false;
          }
        },
      },
    };
  },
  filters: {},
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getWorkDetail();
    }

    this.getWorkTypeTree();
    this.getNeedPeopleTag();
  },
  mounted() {
    window._AMapSecurityConfig = {
      securityJsCode: "793d687f343f36cb5c3a566750020cca",
    };
    AMapLoader.load({
      key: "a15123da54159ae944e685eb86215dc8",
      version: "2.0",
    })
      .then((AMap) => {
        this.AMap = AMap;
        AMap.plugin("AMap.Geocoder", () => {
          this.geocoder = new AMap.Geocoder();
        });
      })
      .catch((e) => {
        console.error(e); //加载错误提示
      });
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getWorkDetail() {
      this.$axios
        .get(`${RECRUIT_HOST}/admin/oddjobsRecruit/info?id=${this.id}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.contact = res.data.data.contact;
            this.phone = res.data.data.phone;
            this.description = res.data.data.description;
            this.lon = res.data.data.location_lng;
            this.lat = res.data.data.location_lat;
            this.address = res.data.data.address;
            this.imgs = res.data.data.img ? res.data.data.img.split(",") : [];
            this.salary = res.data.data.salary_type;
            this.salaryNum = res.data.data.low_salary;
            this.peopleType = res.data.data.staff_composition.id
              ? res.data.data.staff_composition.id
              : "";
            this.needPeople = res.data.data.staff_num.id
              ? res.data.data.staff_num.id
              : "";
            res.data.data.work_type.forEach((item) => {
              this.work_type.push(item.id);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getWorkTypeTree() {
      this.$axios
        .get(`${RECRUIT_HOST}/admin/oddjobsWorkType/tree`)
        .then((res) => {
          if (res.data.code == 0) {
            this.treeList = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getNeedPeopleTag() {
      this.$axios
        .get(`${RECRUIT_HOST}/admin/oddjobsRecruit/tagsDict`)
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.map((x) => {
              if (x.type === "staff_composition")
                this.peopleTypeOption = x.value;
              if (x.type === "staff_num") this.needPeopleOption = x.value;
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    reset() {
      if (!this.id) {
        this.contact = "";
        this.phone = "";
        this.description = "";
        this.work_type = [];
        this.lon = "";
        this.lat = "";
        this.address = "";
        this.imgs = [];
        this.salary = -1;
        this.salaryNum = "";
        this.peopleType = "";
        this.needPeople = "";
      } else {
        this.getWorkDetail();
      }
    },
    submit() {
      if (this.contact == "") {
        this.$message({
          message: "请输入发布人",
          type: "warning",
        });
      } else if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          this.phone
        )
      ) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
      } else if (this.work_type.length == 0) {
        this.$message({
          message: "请选择工作类型",
          type: "warning",
        });
      } else if (this.address == "") {
        this.$message({
          message: "请打开地图选择位置",
          type: "warning",
        });
      } else if (this.description == "") {
        this.$message({
          message: "请输入详细描述",
          type: "warning",
        });
      } else if (this.salary > 0 && this.salaryNum == "") {
        this.$message({
          message: "请输入薪资",
          type: "warning",
        });
      } else if (
        this.peopleType != 10 &&
        this.peopleType != "" &&
        this.needPeople == ""
      ) {
        this.$message({
          message: "请选择招聘人数",
          type: "warning",
        });
      } else {
        let tags = [];
        if (this.peopleType) {
          tags.push(this.peopleType);
        }
        if (this.needPeople) {
          tags.push(this.needPeople);
        }
        let request = {
          description: this.description,
          contact: this.contact,
          phone: this.phone,
          work_type: this.work_type.join(","),
          address: this.address,
          location_lng: this.lon,
          location_lat: this.lat,
        };
        if (this.id) {
          request.id = this.id;
        }
        if (tags.length) {
          request.tags = tags.join(",");
        }
        if (this.imgs.length) {
          request.img = this.imgs.join(",");
        }
        if (this.salary > -1) {
          request.salary_type = this.salary;
        }
        if (this.salaryNum) {
          request.low_salary = this.salaryNum;
        }
        this.$axios
          .post(`${RECRUIT_HOST}/admin/oddjobsRecruit/edit`, request)
          .then((res) => {
            if (res.data.code == 0) {
              this.back();

              this.$message({
                type: "success",
                message: "发布成功!",
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    toUpload(index) {
      this.uploadIndex = index;
      let upload = document.getElementById("upload");
      upload.value = "";
      upload.click();
    },
    fileChange(e) {
      let file = e.target.files[0];
      if (file) {
        const isIMAGE = file.type.indexOf("image/") >= 0;
        if (!isIMAGE) {
          this.$message.error("上传文件只能是图片格式！");
        } else {
          HS_upload(
            file,
            (data) => {
              if (this.uploadIndex == -1) {
                this.imgs.push(data.url);
              } else {
                this.$set(this.imgs, this.uploadIndex, data.url);
              }
            },
            (error) => {
              console.log(error);
            },
            (processPercent) => {
              console.log("processPercent:" + processPercent);
            }
          );
        }
      }
    },
    imgDelete(index) {
      this.imgs.splice(index, 1);
    },
    mapShowFn() {
      this.mapShow = true;
      if (!this.map) {
        this.$nextTick(function () {
          this.map = new AMap.Map("container", {
            zoom: 12,
          });

          var center = this.map.getCenter();
          if (center.lng && center.lat) {
            this.map.setCenter([center.lng, center.lat]);
            this.lon = center.lng;
            this.lat = center.lat;
          }

          this.map.on("click", (evt) => {
            this.geocoder.getAddress(
              [evt.lnglat.lng, evt.lnglat.lat],
              (status, result) => {
                if (status === "complete" && result.info === "OK") {
                  this.lon = evt.lnglat.lng;
                  this.lat = evt.lnglat.lat;
                  this.address = result.regeocode.formattedAddress;

                  this.mapShow = false;
                } else {
                  console.log(status, result);
                }
              }
            );
          });

          this.AMap.plugin("AMap.PlaceSearch", () => {
            this.placeSearch = new AMap.PlaceSearch({
              pageSize: 20, // 单页显示结果条数
              pageIndex: 1, // 页码
              map: this.map, // 展现结果的地图实例
              panel: "panel", // 结果列表将在此容器中进行展示。
              autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            });
            this.AMap.Event.addListener(
              this.placeSearch,
              "markerClick",
              (e) => {
                this.lon = e.data.location.lng;
                this.lat = e.data.location.lat;
                this.address =
                  e.data.pname +
                  e.data.cityname +
                  e.data.adname +
                  e.data.address +
                  e.data.name;

                this.mapShow = false;
              }
            );
            this.AMap.Event.addListener(
              this.placeSearch,
              "listElementClick",
              (e) => {
                this.lon = e.data.location.lng;
                this.lat = e.data.location.lat;
                this.address =
                  e.data.pname +
                  e.data.cityname +
                  e.data.adname +
                  e.data.address +
                  e.data.name;

                this.mapShow = false;
              }
            );
          });
        });
      }
    },
    searchMapFn() {
      if (!this.searchMap) {
        this.$message("请输入搜索地址");
      } else {
        this.placeSearch.search(
          this.searchMap,
          //[this.lon, this.lat],
          //50000,
          (status, result) => {
            if (status === "complete" && result.info === "OK") {
            } else {
              console.log(status, result);
            }
          }
        );
      }
    },
    mapOpen() {
      this.searchMap = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  border-radius: 8px;
  background: #ffffff;
  padding: 32px;

  .contain {
    width: 456px;
  }

  .el-button {
    height: 36px;
    line-height: 20px;
    padding-top: 8px;
  }

  .label {
    color: #4e5969;
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    line-height: 20px;
    margin: 28px 0 8px 0;

    .require {
      color: red;
      display: inline-block;
      margin-right: 3px;
      line-height: 20px;
    }
  }

  .inputItem {
    border-radius: 2px;

    /deep/.el-input__inner {
      height: 36px;
      background: #f6f7f9;
      padding: 0 12px;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
  }

  .chooseLocation {
    margin-bottom: 12px;
  }

  .locationInput {
    /deep/.el-textarea__inner {
      background: #f6f7f9;
      padding: 8px 12px;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
    /deep/.el-input__count {
      background: #f6f7f9;
    }
  }

  .locationInput.is-disabled {
    /deep/.el-textarea__inner {
      color: #c0c4cc;
    }
  }

  .desInput {
    /deep/.el-textarea__inner {
      height: 100px;
      background: #f6f7f9;
      padding: 8px 12px;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
    /deep/.el-input__count {
      background: #f6f7f9;
    }
  }

  .imgContain {
    display: flex;
    flex-wrap: wrap;

    .imgInner {
      position: relative;
      margin-right: 10px;

      .imgDelete {
        width: 20px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .uploadImg {
      width: 80px;
      height: 80px;
      border-radius: 4px;
    }
  }

  .uploadInfo {
    color: #999999;
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFang SC";
    line-height: 20px;
    margin-top: 4px;
  }

  .salaryRadio {
    margin: 12px 0 0 0;
  }

  .salaryInput {
    margin-top: 20px;
  }

  .el-select {
    width: 456px;
    border-radius: 2px;

    /deep/.el-input__inner {
      height: 36px;
      background: #f6f7f9;
      padding: 0 12px;
      border: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
    }
  }

  /deep/.mapContainer {
    .el-dialog__body {
      padding-top: 10px;
      position: relative;

      #container {
        margin-top: 20px;
        widows: 100%;
        height: 500px;
      }

      .searchMap {
        width: 70% !important;
        max-width: 600px;
        margin-right: 20px;

        .el-input__inner {
          width: 100%;
        }
      }

      #panel {
        position: absolute;
        background-color: white;
        max-height: 500px;
        overflow-y: auto;
        top: 80px;
        right: 10px;
        width: 280px;
      }
    }
  }

  .btnContain {
    display: flex;
    justify-content: flex-end;
    margin-top: 22px;

    .resetBtn {
      border: 1px solid #999999;
      background-color: #ffffff;
      color: #666666;
      margin-left: 20px;
    }
  }

  /deep/.main-select-tree {
    .el-tag {
      background-color: #fde7e7;
      border-color: #fbcfcf;
      color: #ea0e0e;

      .el-tag__close {
        background-color: #ffffff;
      }
    }

    .el-input {
      margin-bottom: 0 !important;
      .el-input__inner {
        background: #f6f7f9;
        border: 0;
      }
    }
  }

  .disabledStatus {
    /deep/.el-select__tags {
      cursor: not-allowed;
    }
  }

  /* google、safari */
  /deep/input::-webkit-outer-spin-button,
  /deep/input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
  /* 火狐 */
  /deep/input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
